import { render, staticRenderFns } from "./PermissionsApplicationsList.vue?vue&type=template&id=71c5caca&"
import script from "./PermissionsApplicationsList.vue?vue&type=script&lang=js&"
export * from "./PermissionsApplicationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports